import { render, staticRenderFns } from "./CustomerDetailEvents.vue?vue&type=template&id=7fbe577b&scoped=true&"
import script from "./CustomerDetailEvents.vue?vue&type=script&lang=ts&"
export * from "./CustomerDetailEvents.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerDetailEvents.vue?vue&type=style&index=0&id=7fbe577b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbe577b",
  null
  
)

export default component.exports